import { apiUrl } from "utils/urls";

import axios from "axios";

export const listReviewPage = async (params) => {
    const { data } = await axios.get(apiUrl("review") + `/${params.reference_file_uuid}?page=${params.page}`);
    return data;
};

export const getReviewPdfFile = async (fileUrl) => {
    const apiOrigin = new URL(apiUrl("review")).origin;
    const resolvedFileUrl = new URL(fileUrl, apiOrigin).href;
    // aws s3 파일 접근 시 전역 auth 헤더가 들어가면 접근이 안되서 직접 fetch 사용
    const response = await fetch(resolvedFileUrl);
    if (!response.ok) {
        throw new Error(`PDF file download failed: ${response.status}`);
    }
    return response.arrayBuffer();
};

export const getReviewPageLayout = async ({ reference_file_uuid, page }) => {
    const { data } = await axios.get(apiUrl("review") + `/${reference_file_uuid}/layout`, {
        params: { page },
    });
    return data;
};
